export default {

    state: {
        //just want a few things reactive
        first_name: null,
        last_name: null,
        photo_url: null,
        client_list_all: null,
        clients_through_org: null,
    },

    actions: { 

    },

    mutations: {
        setUser(state, auth_user) {
            Object.assign(state, auth_user); //https://stackoverflow.com/questions/47871046/vuex-why-cant-we-affect-the-whole-state-object
        },
    },
    
    getters: {
        client_list (state, getters, rootState) {
            if (rootState.perms.can_edit_org_clients && !rootState.perms.can_do_everything) {
                return state.clients_through_org;
            }
            else {
                return state.client_list_all;
            }        
        }
    }
};